import axiosInstance from "../../environment/axiosInstances";

export const clientsServices = {
    clientDetail,
    addClientDetail,
    getDevicesList,
    getVerifiedNumbers,
    getBlockedNumbers,
    createBlockedNumbers,
    updateBlockedNumbers,
    deleteBlockedNumbers,
    getTickets,
    getVoiceMailList,
    voiceMailCreate,
    deleteVoiceMail,
    getAddressBookList,
    getCallLogs,
    getSmsLogs,
    deleteDevice,
    getOutboundProviders,
    addDevicesList,
    getSipcredentials,
    getUsage,
    deleteUnassignNumber,
    getAccountLogs,
    addAddressList,
    clinetUpdateDevice,
    deleteVerifiedNumber,
    addVerifiedNumber,
    getSubscriptionAddons,
    addSubscriptionAddons,
    removeSubscriptionAddons,
    getRecomendedAddons,
    SearchAllAddonsforUser,
    getActivityLogs,
    getAppDebugLogs,
    getPaymentTransaction,
    updateEdetails,
    removeE9Status,
    SearchSyncSetting,
    updateefonclient,
    updatePhoneNumber,
    getBusinesSubscriptonAddons,
    getBusinessRecomendedAddons,
    addBusinessSubscriptionAddons,
    deleteBusineSubscription
}

// business addons

function getBusinesSubscriptonAddons(data : any) {
    return axiosInstance.get(`/admin/business-accounts/${data.id}/addons`);
}

function getBusinessRecomendedAddons(data: any) {
    return axiosInstance.get(`/admin/business-accounts/${data.id}/recomanded-addons`);
}

function addBusinessSubscriptionAddons(data: any) {
    const clientId = data.clientId;
    delete data.clientId;
    return axiosInstance.patch(`/admin/business-accounts/${clientId}/add-new-addon`, data);
}

function deleteBusineSubscription(data: any) {
    const clientId = data.clientId;
    // console.log('dataaa__',data)
    return axiosInstance.delete(`/admin/business-accounts/${clientId}/remove-addon/${data.deleteSubscriptionId}`);
}

//end

function getSubscriptionAddons(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}/account-addons`);
}

function addSubscriptionAddons(data: any) {
    const clientId = data.clientId;
    delete data.clientId;
    return axiosInstance.post(`/admin/efone-clients/${clientId}/account-addons`, data);
}

function removeSubscriptionAddons(data: any) {
    const clientId = data.clientId;
    delete data.clientId;
    return axiosInstance.patch(`/admin/efone-clients/${clientId}/account-addons`, data);
}

function removeE9Status(data: any) {
    return axiosInstance.delete(`/admin/efone-clients/${data.clientId}/e911`);
}

function getRecomendedAddons(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}/recomended-addons`);
}
function SearchSyncSetting(data: any) {
    return axiosInstance.get(`/admin/sync-devices/get-setting/${data.id}`);
}

function clientDetail(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}`);
}
function SearchAllAddonsforUser(data: any) {
    return axiosInstance.get(`/admin/efone-clients?limit=100&addonFilters=${data}`);

}

function addClientDetail(data: any) {
    const id = data.id;
    delete data.id;
    return axiosInstance.patch(`/admin/efone-clients/${id}`, data);
}


function updateEdetails(data: any) {
    const id = data.id;
    delete data.id;
    return axiosInstance.patch(`/admin/efone-clients/${id}/e911`, data);
}

function updateefonclient(data: any) {
    const id = data.id;
    delete data.id;
    return axiosInstance.patch(`/admin/efone-clients/${id}/update-services`, data);
}

function updatePhoneNumber(data: any) {
    const id = data.id;
    delete data.id;
    return axiosInstance.patch(`/admin/phone-numbers/${id}/update-services`, data);
}



function getDevicesList(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}/devices`);
}

function addDevicesList(data: any) {
    const id = data.id;
    delete data.id;
    return axiosInstance.post(`/admin/efone-clients/${id}/devices`, data);
}

function addAddressList(data: any) {
    const id = data.id;
    delete data.id;
    return axiosInstance.post(`/admin/efone-clients/${id}/addressbook`, data);
}


function deleteDevice(data: any) {
    return axiosInstance.delete(`/admin/efone-clients/${data.id}/devices/${data.deviceId}`);
}

function deleteUnassignNumber(data: any) {
    return axiosInstance.delete(`/admin/efone-clients/${data.id}/unassign-number`);
}


function deleteBlockedNumbers(data: any) {
    return axiosInstance.delete(`/admin/efone-clients/${data.id}/blockednumbers/${data.blockedNumberId}`);
}

function clinetUpdateDevice(data: any) {
    const id = data.id;
    const deviceId = data.deviceId;
    delete data.id;
    delete data.deviceId;
    return axiosInstance.patch(`/admin/efone-clients/${id}/devices/${deviceId}`, data);
}

function getVerifiedNumbers(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}/mynumbers`);
}

function addVerifiedNumber(data: any) {
    const id = data.id;
    delete data.id;
    return axiosInstance.post(`/admin/efone-clients/${id}/mynumbers`, data);
}

function deleteVerifiedNumber(data: any) {
    return axiosInstance.delete(`/admin/efone-clients/${data.id}/mynumbers/${data.verifiedNumberId}`);
}

function getBlockedNumbers(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}/blockednumbers`);
}

function createBlockedNumbers(data: any) {
    const id = data.id;
    delete data.id;
    return axiosInstance.post(`/admin/efone-clients/${id}/blockednumbers`, data);
}

function updateBlockedNumbers(data: any) {
    const clientId = data.clientId;
    const id = data._id;
    delete data._id;
    delete data.clientId;
    return axiosInstance.patch(`/admin/efone-clients/${clientId}/blockednumbers/${id}`, data);
}


function getTickets(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}/tickets`);
}

function getVoiceMailList(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}/voicemails`);
}

function voiceMailCreate(data: any) {
    return axiosInstance.post(`/admin/efone-clients/${data.id}/voicemails`, data.data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

function deleteVoiceMail(data: any) {
    return axiosInstance.delete(`/admin/efone-clients/${data.id}/voicemails/${data.voicemailId}`);
}

function getAddressBookList(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}/addressbook`);
}

function getCallLogs(data: any, value: any) {

    if (Object.keys(value).length) {
        return axiosInstance.get(`/admin/efone-clients/${data}/calls?limit=50&page=${value.pageLimit}&${value.callNumber}=${value.callSearchKey}&${value.callFromDateData}=${value.startDate}&${value.remainderDateData}=${value.endDate}&${value.providerNameData}=${value.providerName}&${value.callTypeData}=${value.callType}&${value.callErrorData}=${value.callError}&${value.deviceTypeData}=${value.deviceType}&${value.callStatusData}=${value.callStatus}`);
    }
    else {
        return axiosInstance.get(`/admin/efone-clients/${data}/calls?limit=50&page=${value}`);
    }
}


function getSmsLogs(data: any, value: any) {
    if (Object.keys(value).length) {
        return axiosInstance.get(`/admin/efone-clients/${data}/sms?limit=50&page=${value.pageLimit}&${value.id}=${value.SearchKey}&${value.messageStatusData}=${value.messageStatus}&${value.smsDirectionData}=${value.smsDirection}&${value.callFromDateData}=${value.startDate}&${value.remainderDateData}=${value.endDate}`);
    }
    else {
        return axiosInstance.get(`/admin/efone-clients/${data}/sms?limit=50&page=${value}`);
    }
}

function getOutboundProviders(data: any) {
    return axiosInstance.get(`admin/outbound-providers`);
}


function getAccountLogs(data: any, value: any) {
    if (Object.keys(value).length) {
        return axiosInstance.get(`/admin/efone-clients/${data}/account-logs?limit=50&page=${value.pageLimit}&type=${value.type}`);
    }
    else {
        return axiosInstance.get(`/admin/efone-clients/${data}/account-logs?limit=50&page=${value}`);
    }
}

function getSipcredentials() {
    return axiosInstance.get(`/admin/efone-clients/sip-credentials`);
}

function getUsage(data: any) {
    return axiosInstance.get(`/admin/efone-clients/${data.id}/usage`);
}

function getActivityLogs(data: any, value: any) {
    return axiosInstance.get(`/admin/efone-clients/${data}/activity-logs?limit=50&page=${value}`);
}

function getPaymentTransaction(data: any) {
    return axiosInstance.get(`admin/efone-clients/${data.id}/payment-history?limit=100`);
}

function getAppDebugLogs(data: any, value: any) {
    return axiosInstance.get(`/admin/efone-clients/${data}/app-debug-logs?limit=50&page=${value}`);
}

